(() => {
  const NOTE_PROP_NAME = '_Kommentar';

  const root =
    (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  // Finn side-handlekurv-root (best effort)
  const findDrawerRoot = () => (
    document.querySelector('#CartDrawer') ||
    document.querySelector('[data-cart-drawer]') ||
    document.querySelector('.cart-drawer') ||
    document.querySelector('.drawer--cart') ||
    document.querySelector('.cart-sidebar') ||
    document.querySelector('[class*="drawer"][class*="cart"]') ||
    document.querySelector('[class*="cart"][class*="drawer"]')
  );

  const isVisible = (el) => !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));

  const parseQuery = (href) => {
    try {
      const u = new URL(href, window.location.origin);
      const out = {};
      u.searchParams.forEach((v, k) => (out[k] = v));
      return out;
    } catch {
      return {};
    }
  };

  // Prøv å finne line-item key (best), ellers line number (fallback)
  const getLineIdentifier = (itemEl) => {
    // 1) dataset-varianter
    const ds = itemEl.dataset || {};
    const key =
      ds.key ||
      ds.lineKey ||
      ds.lineItemKey ||
      ds.cartItemKey ||
      ds.itemKey;

    if (key) return { type: 'id', value: key };

    // 2) Se etter remove-link med id i querystring
    const removeLink = itemEl.querySelector('a[href*="cart/change"], a[href*="/cart/change"], a[href*="cart_change"]');
    if (removeLink) {
      const q = parseQuery(removeLink.getAttribute('href') || '');
      if (q.id) return { type: 'id', value: q.id };
      if (q.line) return { type: 'line', value: Number(q.line) };
    }

    // 3) Se etter quantity input med data-index (ofte 1-basert line)
    const qtyInput = itemEl.querySelector('input[name="updates[]"][data-index]');
    if (qtyInput && qtyInput.dataset.index) {
      const n = Number(qtyInput.dataset.index);
      if (Number.isFinite(n) && n > 0) return { type: 'line', value: n };
    }

    return null;
  };

  const saveNote = async (identifier, value) => {
    const payload = {
      properties: { [NOTE_PROP_NAME]: value ?? '' }
    };

    // Shopify Ajax /cart/change.js støtter både "id" (line item key) og ofte "line" (linjenummer)
    if (identifier.type === 'id') payload.id = identifier.value;
    else payload.line = identifier.value;

    const res = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      keepalive: true,
      body: JSON.stringify(payload)
    });

    // Ikke kast hardt – vi vil ikke kræsje cart opplevelsen
    if (!res.ok) return false;
    return true;
  };

  const buildNoteBlock = (identifier) => {
    const wrap = document.createElement('div');
    wrap.className = 'cart-item__note';
    wrap.style.marginTop = '.5rem';
    wrap.style.width = '100%';

    const label = document.createElement('label');
    label.textContent = 'Kommentar til dette produktet';
    label.style.display = 'block';
    label.style.fontSize = '13px';
    label.style.marginBottom = '.35rem';

    const ta = document.createElement('textarea');
    ta.className = 'input';
    ta.rows = 2;
    ta.placeholder = 'Skriv kommentar her…';
    ta.style.width = '100%';
    ta.style.boxSizing = 'border-box';
    ta.style.resize = 'vertical';

    // Bruk dataset for å kunne lagre senere
    ta.dataset.noteType = identifier.type;
    ta.dataset.noteValue = String(identifier.value);

    // Lagre KUN på blur (minimerer API-kall og re-render-problemer)
    ta.addEventListener('blur', async () => {
      const id = { type: ta.dataset.noteType, value: ta.dataset.noteType === 'line' ? Number(ta.dataset.noteValue) : ta.dataset.noteValue };
      ta.classList.add('is-saving');
      await saveNote(id, ta.value ?? '');
      ta.classList.remove('is-saving');
    });

    wrap.appendChild(label);
    wrap.appendChild(ta);
    return wrap;
  };

  const injectIntoDrawerOnce = () => {
    const drawer = findDrawerRoot();
    if (!drawer || !isVisible(drawer)) return;

    // Finn varelinjer i drawer: prøv noen vanlige wrappers
    const itemEls = drawer.querySelectorAll(
      '[data-cart-item], .cart-item, [class*="cart-item"], li'
    );

    itemEls.forEach((itemEl) => {
      // Ikke legg inn to ganger
      if (itemEl.querySelector('textarea[data-note-type][data-note-value]')) return;

      const ident = getLineIdentifier(itemEl);
      if (!ident) return;

      // Prøv å plassere i “tekstkolonnen” ved å finne en link med titteltekst (ikke bilde)
      const titleLink = Array.from(itemEl.querySelectorAll('a[href*="/products/"]'))
        .find((a) => !a.querySelector('img') && (a.textContent || '').trim().length > 0 && a.getAttribute('aria-hidden') !== 'true');

      const noteBlock = buildNoteBlock(ident);

      if (titleLink && titleLink.parentElement) {
        titleLink.insertAdjacentElement('afterend', noteBlock);
      } else {
        itemEl.appendChild(noteBlock);
      }
    });
  };

  // Kjør når drawer sannsynligvis åpnes:
  // - ved klikk på cart-ikon/knapper
  // - og en gang ved load
   const startDrawerWatcher = () => {
    // Kjører kort og stopper av seg selv (ingen spam)
    let tries = 0;
    const maxTries = 30; // ca 6 sek hvis 200ms
    const timer = setInterval(() => {
      tries += 1;
      injectIntoDrawerOnce();

      // Stopp hvis vi allerede har injisert minst ett felt i en synlig drawer
      const drawer = findDrawerRoot();
      const injected = drawer && drawer.querySelector('textarea[data-note-type][data-note-value]');
      if (injected || tries >= maxTries) clearInterval(timer);
    }, 200);
  };

  // Når siden lastes
  window.addEventListener('load', () => {
    startDrawerWatcher();
  });

  // Når bruker trykker på noe (åpner ofte drawer)
  document.addEventListener('click', () => {
    startDrawerWatcher();
  });

  // Når man trykker ESC / lukker/åpner via tastatur (noen tema gjør dette)
  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') startDrawerWatcher();
  });

  // Hvis tema åpner drawer via custom events (best effort)
  document.addEventListener('cart:open', startDrawerWatcher);
  document.addEventListener('cart:updated', startDrawerWatcher);


  // Cart-siden din har allerede textarea i Liquid, den lagrer via blur om du vil:
  // Hvis du vil ha blur-lagring på cart-siden også, kan du gjenbruke samme dataset-metode der.
})();
